import { render, staticRenderFns } from "./VendorReport.vue?vue&type=template&id=88b7e520"
import script from "./VendorReport.vue?vue&type=script&lang=js"
export * from "./VendorReport.vue?vue&type=script&lang=js"
import style0 from "./VendorReport.vue?vue&type=style&index=0&id=88b7e520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports